import { styled } from "../../styles";

export const StyledBaselineTooltipBox = styled("div", {
  borderRadius: "4px",
  padding: "12px 32px",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  backgroundColor: "$charcoal",
  pointerEvents: "none",
  whiteSpace: "nowrap",
  width: "max-content",
});

export const StyledBaselineHeader = styled("div", {
  display: "flex",
  fontSize: "$text-md",
  fontWeight: 500,
  gap: "4px",
  color: "$white",
  fontFamily: "$openSans",
});

export const StyledBaselineDate = styled("div", {
  display: "flex",
  fontSize: "$text-md",
  fontWeight: 500,
  color: "$gray-60",
  fontFamily: "$openSans",

  variants: {
    hasValues: {
      true: {
        marginBottom: "8px",
      },
    },
  },
});

export const StyledBaselineValues = styled("div", {
  display: "flex",
  flexDirection: "column",
  fontSize: "12px",
  opacity: 0.85,
  color: "$white",
  fontFamily: "$openSans",
});

export const StyledBaselineValueRow = styled("div", {
  display: "flex",
  gap: "4px",
});
